import React from 'react';
import { Box, Typography } from '@material-ui/core';
import BaseWidth from '../../components/base-width';

const CorporateIdentitityBase = ({ children }) => (
  <BaseWidth maxWidth={'lg'}>
    <Typography component="span" variant="body1">
      <Box pt={5} pb={7}>
        {children}
      </Box>
    </Typography>
  </BaseWidth>
);

export default React.memo(CorporateIdentitityBase);
